import { SetAfterProfilePanel } from './general.types';

const initialState: WebOrder.State.General = {
  afterProfilePanelUrl: undefined,
};

export const generalReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: WebOrder.State.General = initialState,
  action: SetAfterProfilePanel,
): WebOrder.State.General => {
  switch (action.type) {
    case 'SET_AFTER_PROFILE_PANEL_URL': {
      return {
        ...state,
        afterProfilePanelUrl: action.payload,
      };
    }

    default:
      return state;
  }
};
